import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const EditPencil: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M19.5 11.5L12.5 4.5M19.5 11.5L22.5 8.5L15.5 1.5L12.5 4.5M19.5 11.5L9 22H2V15L12.5 4.5'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default EditPencil
